import { useNavigate } from "react-router-dom";
import { comprehensiveSer } from "../../../../types/marriageSevices";

import { ServiceDetails } from "../../../../types/alhadeed";
import { useDispatch } from "react-redux";

import { setNewPackageModelTrue } from "../../../../store/slices/modalSlice";
import PackageFlowModel from "../../../../components/model/PackageFlowModel";
import { useCart } from "../../../../hooks/useCart";
import { useEffect, useRef } from "react";
import { AnimatedNumber } from "../../../../components/cardItem/AnimatedNumber";

interface Props {
  data?: comprehensiveSer;
  apidata?: ServiceDetails[];
}
const ComprehensiveService: React.FC<Props> = ({ data, apidata }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { getPriceIdByServiceId, countByService, getData } = useCart();
  useEffect(() => {
    getData();
  }, []);

  const lastUrlRef = useRef<string | null>(null);

  const handleOpenPackageModal = (service: ServiceDetails) => {
    if (!service?.ServiceId) return;
    if (service?.PriceId) {
      sessionStorage.setItem(
        "PriceRecordId",
        JSON.stringify(service.PriceId)
      );
    }
    sessionStorage.setItem(
      "serviceid",
      JSON.stringify(service.ServiceId)
    );
    lastUrlRef.current = service.URL || null;
    dispatch(setNewPackageModelTrue());
  };
  const handleAddToCartSuccess = () => {
    if (lastUrlRef.current) {
      navigate(`/${lastUrlRef.current}`);
      lastUrlRef.current = null;
    }
  };

  return (
    <>
      <section className="bg-2 py-5 py-md-5 ">
        <div className="container">
          <div className="row">
            <div className="hd-style-2 mb-5 ">
              <h2
                className="font-35 ff-bold"
                dangerouslySetInnerHTML={{
                  __html: data?.heading ?? "",
                }}
              ></h2>
            </div>

            {apidata?.map((service) => (
              <div className="col-md-3 mt-5" key={service.ServiceId}>
                <div className="personal-card bg-white p-md-3 p-2 rounded shadow-sm mt-3">
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="margin-minus-50">
                      <img
                        src={service?.img}
                        alt={service?.imgAlt}
                        height={70}
                      />
                    </div>
                  </div>
                  <div>
                    <h3
                      className="font-14 ff-bold mb-1 text-black mt-2 serv-title"
                      dangerouslySetInnerHTML={{
                        __html: service?.serviceName ?? "",
                      }}
                    ></h3>
                    <p
                      className="font-12 text-black mb-1"
                      dangerouslySetInnerHTML={{
                        __html: service?.insidePageDescription ?? "",
                      }}
                    ></p>
                    <div className="text-center mt-2">
                      {getPriceIdByServiceId(service?.ServiceId ?? 0) ? (
                        <div className="d-flex align-items-center btn-add position-relative gap-1 gap-md-2 justify-content-center">
                          {/* <button className="bt-mi p-0">-</button> */}
                          <span className="counter-numbers">
                            <AnimatedNumber value={countByService(service?.ServiceId ?? 0) || 0} />
                          </span>
                          {/* <button className="bt-plu p-0">+</button> */}
                        </div>
                      ) : (
                        <button
                          className="btn btn-primary font-14 ff-semibold bt--cart"
                          onClick={() => handleOpenPackageModal(service)}
                        >
                          Book Now
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <PackageFlowModel onAddToCartSuccess={handleAddToCartSuccess} />
    </>
  );
};

export default ComprehensiveService;
